export function isBuiltLocally() {
  return window.location.href.indexOf('localhost') !== -1;
}
